import React from 'react'
import {Icon} from '@chakra-ui/react'

const RightIcon = (props) => {
    return (
        <Icon viewBox="0 0 24 24" {...props} aria-hidden="true">
            <path
                id="arrow"
                d="M2.00525 11.4999H19.5953L17.3053 9.20995C16.9153 8.81995 16.9153 8.18995 17.3053 7.79995C17.6953 7.40995 18.3253 7.40995 18.7153 7.79995L22.7153 11.7899C22.8053 11.8799 22.8853 11.9899 22.9353 12.1199C23.0353 12.3599 23.0353 12.6399 22.9353 12.8799C22.8853 12.9999 22.8153 13.1099 22.7153 13.2099L18.7153 17.2099C18.5153 17.4099 18.2653 17.4999 18.0053 17.4999C17.7453 17.4999 17.4953 17.3999 17.2953 17.2099C16.9053 16.8199 16.9053 16.1899 17.2953 15.7999L19.5853 13.5099H1.99525C1.44526 13.5099 0.995255 13.0599 0.995255 12.5099C0.995255 11.9599 1.44526 11.5099 1.99525 11.5099L2.00525 11.4999Z"
                fill="currentColor"
            />
        </Icon>
    )
}

export default RightIcon
